export default "__VITE_ASSET__xdV0UEvJ__"